<template>
  <SfModalPortal
    modal-id="reports/clear-forecast-confirm"
    size="xs"
    @opened="openModal"
    @close="closeModal"
  >
    <template #title>
      {{ I18n.t('reports.forecast.clear_forecast_confirm.title') }}
    </template>

    <template #body>
      <div>{{ I18n.t('reports.forecast.clear_forecast_confirm.body') }}</div>
    </template>

    <template #footer>
      <SfButtonDs
        variant="danger"
        data-testid="clear-forecast-confirm-button"
        @click="handleConfirm"
      >
        {{ I18n.t('reports.forecast.clear_forecast_confirm.ok') }}
      </SfButtonDs>
      <SfButtonDs variant="secondary" @click="closeModal">
        {{ I18n.t('common.cancel') }}
      </SfButtonDs>
    </template>
  </SfModalPortal>
</template>

<script setup lang="ts">
import type { Payload } from '../types/clear-forecast-confirm-modal'

import useI18n from '@app/shared/vue/composables/use-I18n'

import { SfModalPortal } from '@app/shared/vue/components/sf-modal'
import SfButtonDs from '@app/shared/vue/components/sf-button/sf-button-ds.vue'

const I18n = useI18n()

let modalPayload: Payload

function openModal(localModalPayload: Payload) {
  modalPayload = localModalPayload
}

function handleConfirm() {
  closeModal()
  modalPayload.onConfirm()
}

function closeModal() {
  window.modalCitizen.closeModalPortal()
}
</script>
